import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"vertical-align":"middle"} }
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = { slot: "label" }
const _hoisted_4 = { slot: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmSelect(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, [
                      _createElementVNode("b", null, [
                        _createElementVNode("span", _hoisted_1, [
                          _createVNode(_component_ion_icon, { icon: _ctx.thumbsUpOutline }, null, 8, ["icon"])
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode("  1-4 disciplines"))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_reorder_group, {
          onIonItemReorder: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doReorder($event, _ctx.chosenDisciplines))),
          disabled: false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenDisciplines, (discipline, idx) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                lines: "full",
                key: idx,
                style: {"--min-height":"55px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_reorder, {
                    mode: "ios",
                    slot: "start",
                    style: {"margin-inline-end":"0"}
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ion_textarea, {
                      modelValue: discipline.reason,
                      "onUpdate:modelValue": ($event: any) => ((discipline.reason) = $event),
                      placeholder: `Why?`,
                      "label-placement": "stacked",
                      fill: "solid",
                      "auto-grow": true,
                      rows: 3
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_ion_text, {
                            color: discipline.reason ? 'success' : 'danger',
                            style: {"transform":"none"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(idx+1) + ". " + _toDisplayString(discipline.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      color: "medium",
                      class: "no-text-transform",
                      onClick: _withModifiers(($event: any) => (discipline.reason = _ctx.settings.templateReason), ["stop"])
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("small", null, "Template", -1)
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      color: "medium",
                      class: "no-text-transform",
                      onClick: ($event: any) => (_ctx.openProgramModal(discipline)),
                      style: {"margin-top":"4px","margin-bottom":"4px"}
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("small", null, "Programs", -1)
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_textarea, {
                      modelValue: discipline.action,
                      "onUpdate:modelValue": ($event: any) => ((discipline.action) = $event),
                      "label-placement": "stacked",
                      fill: "solid",
                      "auto-grow": true,
                      rows: 2
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_ion_text, {
                            color: discipline.action ? 'success' : 'danger',
                            style: {"transform":"none"}
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode("Your actions / preparations")
                            ])),
                            _: 2
                          }, 1032, ["color"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      color: "medium",
                      class: "no-text-transform",
                      onClick: _withModifiers(($event: any) => (discipline.action = _ctx.settings.templateAction), ["stop"])
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("small", null, "Template", -1)
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenDiscipline(idx, discipline)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.trashOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, { class: "ion-margin-top ion-justify-content-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              class: "add-item-btn",
              color: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDisciplineDeckModal()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.add
                }, null, 8, ["icon"]),
                _cache[8] || (_cache[8] = _createTextVNode(" Discipline(s) "))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}